import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./case.scss?vue&type=style&index=0&lang=scss"
import "./layout.scss?vue&type=style&index=1&lang=scss"

const __exports__ = script;

export default __exports__